export default __webpack_public_path__ + "static/media/email.8641c980.svg";